import React, { useState } from "react";
import { TabSelectDropdownMenu } from "../TabSelectDropdownMenu/TabSelectDropdownMenu";
import {
  TabSelectMenuGridPane,
  MenuItem
} from "../TabSelectDropdownMenu/TabSelectMenuGridPane";
import { TabSelectMenuListPane } from "../TabSelectDropdownMenu/TabSelectMenuListPane";
import { getMaxTabMenuHeight } from "../utils";
import { ListItem, ChapterListItem } from "../ListItems";
import { ChapterCtx, StateChapter } from "components/Chapter/ChapterContainer";
import { Book } from "api/typedefs/Bible";
import BookChapterIcon from "icons/BookChapterIcon";
import BookFlipPageIcon from "icons/BookFlipPageIcon";
import InformationCircleIcon from "icons/InformationCircleIcon";

interface AllBookChapterListProps {
  books: Book[];
  chapter: ChapterCtx;
  handleChapterClick: (chapterInfo: {
    bibleId: string;
    chapterId: string;
  }) => void;
}

export const AllBookChapterList = ({
  books,
  chapter,
  handleChapterClick
}: AllBookChapterListProps) => {
  const [activeMenuKey, setActiveMenuKey] = useState<string>("books");
  const [activeBookId, setActiveBookId] = useState(
    chapter.getChapter()?.bookId || ""
  );

  const bookMenu = books.map(book => ({
    key: book.id,
    onSelect: () => {
      setActiveBookId(book.id);
      setActiveMenuKey("chapters");
    },
    searchValues: [book.abbreviation, book.name],
    render: (props: any) => <ListItem {...props}>{book.name}</ListItem>
  }));

  const activeChapter = books.find(({ id }) => id === activeBookId);
  const chapterMenu = activeChapter
    ? activeChapter.chapters.map((chapter: StateChapter) => ({
        key: chapter.id,
        onSelect: () =>
          handleChapterClick({
            chapterId: chapter.id,
            bibleId: chapter.bibleId
          }),
        searchValues: [chapter.number],
        render: (props: any) => (
          <ChapterListItem {...props}>
            {chapter.number === "intro" ? (
              <InformationCircleIcon size={24} />
            ) : (
              chapter.number
            )}
          </ChapterListItem>
        )
      }))
    : ([] as MenuItem[]);

  const maxListHeight = getMaxTabMenuHeight();

  return (
    <TabSelectDropdownMenu
      activeMenuKey={activeMenuKey}
      onTabClick={(menuKey: string) => {
        setActiveMenuKey(menuKey);
      }}
      menus={[
        {
          tab: <BookFlipPageIcon size={24} />,
          tabPaneComponent: (props: any) => (
            <TabSelectMenuListPane {...props} maxListHeight={maxListHeight} />
          ),
          key: "books",
          activeMenuItemIndex: bookMenu.findIndex(
            ({ key }) => key === activeBookId
          ),
          menuItems: bookMenu
        },
        {
          tab: <BookChapterIcon size={24} />,
          tabPaneComponent: (props: any) => (
            <TabSelectMenuGridPane {...props} maxListHeight={maxListHeight} />
          ),
          key: "chapters",
          activeMenuItemIndex: bookMenu.findIndex(
            ({ key }) => key === activeBookId
          ),
          menuItems: chapterMenu
        }
      ]}
    />
  );
};
